import { ethers } from 'ethers';
import { LEVER_SWAP_CONFIG } from './swapConfig';

function shortAddress(address) {
  if (!address) return '—';
  return `${address.slice(0, 6)}…${address.slice(-4)}`;
}

function normalizeAmount(value) {
  try {
    return BigInt(value || '0');
  } catch {
    return BigInt(0);
  }
}

export function buildPreRealExecutionPlan(swapResult) {
  const allowanceChecks = Array.isArray(swapResult?.allowanceChecks) ? swapResult.allowanceChecks : [];
  const approvalsNeeded = allowanceChecks
    .filter((item) => !item.isEnough)
    .map((item) => ({
      tokenAddress: item.tokenAddress,
      spender: item.spender,
      requiredAmountRaw: item.requiredAmountRaw,
      currentAllowanceRaw: item.allowanceRaw,
      approveAmountRaw: ethers.MaxUint256.toString(),
      label: `${shortAddress(item.tokenAddress)} → ${shortAddress(item.spender)}`,
    }));

  const valueBN = normalizeAmount(swapResult?.txData?.value);

  return {
    dryRunOnly: LEVER_SWAP_CONFIG.DRY_RUN_ONLY,
    sendReady: Boolean(swapResult?.validation?.ok && swapResult?.txData?.to && swapResult?.txData?.data),
    approvalsNeeded,
    needsApproval: approvalsNeeded.length > 0,
    txPreview: {
      to: swapResult?.txData?.to || null,
      valueRaw: valueBN.toString(),
      valueDisplay: ethers.formatEther(valueBN),
      dataBytes: swapResult?.txData?.data ? Math.max(0, (swapResult.txData.data.length - 2) / 2) : 0,
    },
  };
}

export async function approveMaxIfEnabled({ signer, approval }) {
  if (LEVER_SWAP_CONFIG.DRY_RUN_ONLY) {
    throw new Error('Real approvals are disabled while DRY_RUN_ONLY is true.');
  }
  const abi = ['function approve(address spender, uint256 amount) returns (bool)'];
  const token = new ethers.Contract(approval.tokenAddress, abi, signer);
  const tx = await signer.sendTransaction({to:approval.tokenAddress,data:token.interface.encodeFunctionData('approve',[approval.spender,approval.approveAmountRaw])});
  return tx.wait();
}

export async function sendPreparedSwapIfEnabled({ signer, txData }) {
  if (LEVER_SWAP_CONFIG.DRY_RUN_ONLY) {
    throw new Error('Real swaps are disabled while DRY_RUN_ONLY is true.');
  }
  return signer.sendTransaction({
    to: txData.to,
    data: txData.data,
    value: txData.value || '0',
    gasLimit: txData.gas || txData.gasLimit,
  });
}
